function initGradientForm() {
    // form
    const form = document.querySelector('#small-form')
    const formSteps = document.querySelector('#form-steps')
    const formText = document.querySelector('#form-text')

    const stepBlock1 = document.querySelector('#step-0')
    const stepBlock2 = document.querySelector('#step-1')
    const stepBlock3 = document.querySelector('#step-2')
    // btns
    const stepBtn1 = document.querySelector('#step-btn-1')
    const stepBtnBack = document.querySelector('#step-btn-back')
    const submitBtn = document.querySelector('#submit-btn')

    // counter
    const stepCounter = document.querySelector('#step-counter')

    // inputs
    const firstNameInput = document.querySelector('#first_name')
    const lastNameInput = document.querySelector('#last_name')
    const phoneNameInput = document.querySelector('#phone')
    const emailInput = document.querySelector('#email')
    const projectInput = document.querySelector('#project')
    const termsCheckbox = document.querySelector('#terms')

    // labels
    const firstNameLabel = document.querySelector('#first-name-label')
    const lastNameLabel = document.querySelector('#last-name-label')
    const emailLabel = document.querySelector('#email-label')
    const phoneLabel = document.querySelector('#phone-label')
    const projectLabel = document.querySelector('#project-label')

    // errors
    const firstError = document.querySelector('#first-error')
    const lastError = document.querySelector('#last-error')
    const commonError = document.querySelector('#common-error')
    const emailError = document.querySelector('#email-error')
    const projectError = document.querySelector('#project-error')
    const termsError = document.querySelector('#terms-error')
    const requiredErrorMessage = 'All fields marked with an asterisk are required'
    let isFormSent = false
    const emailReg = new RegExp(/^[\w-\.]+@([\w-]+\.)+[\w-]{2,63}$/)
    const nameReg = new RegExp(/^[a-zA-Z]+( [a-zA-Z ]+)*$/)

    let currentStep = 0

    const formValues = {
        firstName: '',
        lastName: '',
        email: '',
        project: '',
        phone: '',
        terms: false,
    }

    const formErrors = {
        firstName: '',
        lastName: '',
        email: '',
        project: '',
        terms: '',
    }

    const maxCharacters = 16

    phoneNameInput.addEventListener('input', function () {
        let inputValue = this.value.replace(/\D/g, '')

        if (!inputValue.startsWith('+')) {
            inputValue = '+' + inputValue
        }

        if (inputValue.length > maxCharacters) {
            inputValue = inputValue.substring(0, maxCharacters)
        }

        phoneLabel.classList.add('hide')
        this.value = inputValue
    })

    phoneNameInput.addEventListener('blur', function () {
        formValues.phone = this.value
    })

    function checkStepBlocks() {
        if (currentStep === 0) {
            stepBlock1.classList.add('show')
            stepBlock2.classList.remove('show')
            stepBlock3.classList.remove('show')
            form.classList.remove('step2')
        }

        if (currentStep === 1) {
            stepBlock1.classList.remove('show')
            stepBlock2.classList.add('show')
            stepBlock3.classList.remove('show')
            form.classList.add('step2')
        }

        stepCounter.textContent = `Step ${currentStep + 1}`
    }

    stepBtn1.addEventListener('click', (e) => {
        e.preventDefault()

        if (isStep1FormValid()) {
            currentStep++
            checkStepBlocks()
            firstNameInput.classList.remove('error-input')
            lastNameInput.classList.remove('error-input')
            firstError.classList.remove('show')
            lastError.classList.remove('show')
        }
    })

    stepBtnBack.addEventListener('click', e => {
        e.preventDefault()

        currentStep--
        checkStepBlocks()
    })

    firstNameInput.addEventListener('input', function () {
        if (this.value.length) {
            firstNameLabel.classList.add('hide')
        } else {
            firstNameLabel.classList.remove('hide')
        }
    })

    firstNameInput.addEventListener('blur', function () {
        formValues.firstName = this.value
    })

    lastNameInput.addEventListener('input', function () {
        if (this.value.length) {
            lastNameLabel.classList.add('hide')
        } else {
            lastNameLabel.classList.remove('hide')
        }
    })

    lastNameInput.addEventListener('blur', function () {
        formValues.lastName = this.value
    })

    emailInput.addEventListener('input', function () {
        if (this.value.length) {
            emailLabel.classList.add('hide')
        } else {
            emailLabel.classList.remove('hide')
        }
    })

    emailInput.addEventListener('blur', function () {
        formValues.email = this.value.trim()
    })

    projectInput.addEventListener('input', function () {
        if (this.value.length) {
            projectLabel.classList.add('hide')
        } else {
            projectLabel.classList.remove('hide')
        }
    })

    projectInput.addEventListener('blur', function () {
        formValues.project = this.value
    })

    termsCheckbox.addEventListener('change', (e) => {
        formValues.terms = e.target.checked
    })

    submitBtn.addEventListener('click', (e) => {
        if (!isStep2FormValid() || isFormSent) {
            e.preventDefault()
            return
        }
        isFormSent = true
    })

    document.addEventListener('wpcf7mailsent', function (event) {
        stepBlock3.classList.add('show')
        stepBlock1.classList.remove('show')
        stepBlock2.classList.remove('show')
        formText.classList.add('hide')
        formSteps.classList.add('hide')
        form.classList.add('finished')
        form.classList.remove('step2')
    })

    function handleErrorVisibility(errorInput, formField, errorMessage) {
        errorInput.textContent = errorMessage

        if (errorMessage) {
            formField.classList.add('error-input')
            errorInput.classList.add('show')
        } else {
            formField.classList.remove('error-input')
            errorInput.classList.remove('show')
        }
    }

    function firstNameValidate() {
        const value = formValues.firstName.replace(' ', '')

        if (!value) {
            formErrors.firstName = 'Enter your first name.'
        } else {
            formErrors.firstName = ''
        }

        handleErrorVisibility(firstError, firstNameInput, formErrors.firstName)
    }

    function lastNameValidate() {
        const value = formValues.lastName.replace(' ', '')

        if (!value) {
            formErrors.lastName = 'Enter your last name.'
        } else {
            formErrors.lastName = ''
        }

        handleErrorVisibility(lastError, lastNameInput, formErrors.lastName)
    }

    function emailValidate() {
        const value = formValues.email

        if (!value) {
            formErrors.email = 'Enter your email address.'
        } else if (!emailReg.test(value)) {
            formErrors.email = 'Enter a valid email address.'
        } else {
            formErrors.email = ''
        }

        handleErrorVisibility(emailError, emailInput, formErrors.email)
    }

    function projectValidate() {
        const value = formValues.project.trim()

        if (!value) {
            formErrors.project = 'Add some details about your project.'
        } else {
            formErrors.project = ''
        }

        handleErrorVisibility(projectError, projectInput, formErrors.project)
    }

    function termsValidate() {
        const value = formValues.terms

        if (!value) {
            formErrors.terms = 'Check the box to proceed.'
        } else {
            formErrors.terms = ''
        }

        handleErrorVisibility(termsError, termsCheckbox, formErrors.terms)
    }

    function isStep1FormValid() {
        firstNameValidate()
        lastNameValidate()

        return !formErrors.firstName && !formErrors.lastName
    }

    function isStep2FormValid() {
        emailValidate()
        projectValidate()
        termsValidate()

        return !formErrors.email && !formErrors.project && !formErrors.terms
    }

    checkStepBlocks()
}

initGradientForm()
